(function () {
	'use strict';

	var mod = angular.module('uwAgenda.global');
	mod.directive('inlineImage', ['$timeout', InlineImageFn]);

	// directive to set the max-width for inline images to 100% of the parent div
	function InlineImageFn($timeout) {
		var directive = {
			link: link,
			restrict: 'A'
		};
		return directive;

		function link(scope, element, attrs) {
			var timer = $timeout(function () {
				var images = element[0].querySelectorAll("img");
				var el = null;
				if (images) {
					for (var i = 0; i < images.length; i++) {
						el = angular.element(images[i]);
						el.addClass('max-image-width');
					}
				}
			}, 0);
		}
	}

})();